import type { FavoriteView, FavoriteViewFolder } from '@/api/favorites'
import { createContext } from 'react'

export interface FavoriteViewsPageActions {
  onOpenFolder: (folderId: string) => void
  onBack: () => void
  onOpenView: (view: FavoriteView) => void
  onRenameView: (view: FavoriteView, title: string) => Promise<boolean>
  onDeleteView: (view: FavoriteView) => void
  onShareView: (view: FavoriteView) => void
  onRenameFolder: (folder: FavoriteViewFolder) => void
  onDeleteFolder: (folder: FavoriteViewFolder) => void
}

const FavoriteViewsPageActionsContext = createContext<FavoriteViewsPageActions | undefined>(undefined)

export { FavoriteViewsPageActionsContext }
